<template>
  <div class="d-flex flex-row justify-content-center">
    <div class="btn btn-sm btn-default py-0 d-flex justify-content-center rewind-btn" @click="rewind()">
      <svg xmlns="http://www.w3.org/2000/svg" class="my-auto" width="24" height="24" :fill="SITE_COLORS.primary" viewBox="0 0 24 24">
        <path
          d="M11.99 5V2.21c0-.45-.54-.67-.85-.35L7.35 5.65c-.2.2-.2.51 0 .71l3.79 3.79c.31.31.85.09.85-.35V7c3.73 0 6.68 3.42 5.86 7.29-.47 2.27-2.31 4.1-4.57 4.57-3.57.75-6.75-1.7-7.23-5.01-.06-.48-.48-.85-.98-.85-.6 0-1.08.53-1 1.13.62 4.39 4.8 7.64 9.53 6.72 3.12-.61 5.63-3.12 6.24-6.24.99-5.13-2.9-9.61-7.85-9.61zm-1.1 11h-.85v-3.26l-1.01.31v-.69l1.77-.63h.09V16zm4.28-1.76c0 .32-.03.6-.1.82s-.17.42-.29.57-.28.26-.45.33-.37.1-.59.1-.41-.03-.59-.1-.33-.18-.46-.33-.23-.34-.3-.57-.11-.5-.11-.82v-.74c0-.32.03-.6.1-.82s.17-.42.29-.57.28-.26.45-.33.37-.1.59-.1.41.03.59.1.33.18.46.33.23.34.3.57.11.5.11.82v.74zm-.85-.86c0-.19-.01-.35-.04-.48s-.07-.23-.12-.31-.11-.14-.19-.17-.16-.05-.25-.05-.18.02-.25.05-.14.09-.19.17-.09.18-.12.31-.04.29-.04.48v.97c0 .19.01.35.04.48s.07.24.12.32.11.14.19.17.16.05.25.05.18-.02.25-.05.14-.09.19-.17.09-.19.11-.32.04-.29.04-.48v-.97z"
        />
      </svg>
    </div>
    <div class="btn btn-sm btn-default play-btn-container py-0 mx-2 d-flex justify-content-center" @click="$emit('pushPlay')" ref="myBtn">
      <i :class="playing ? 'fa-pause' : 'fa-play'" id="player-play" class="fa fa-2x fa-fw"></i>
    </div>
    <div class="btn btn-sm btn-default py-0 d-flex justify-content-center forward-btn" @click="forward()">
      <svg xmlns="http://www.w3.org/2000/svg" class="my-auto" width="24" height="24" :fill="SITE_COLORS.primary" viewBox="0 0 24 24">
        <path
          d="M18.92 13c-.5 0-.91.37-.98.86-.48 3.37-3.77 5.84-7.42 4.96-2.25-.54-3.91-2.27-4.39-4.53C5.32 10.42 8.27 7 12 7v2.79c0 .45.54.67.85.35l3.79-3.79c.2-.2.2-.51 0-.71l-3.79-3.79c-.31-.31-.85-.09-.85.36V5c-4.94 0-8.84 4.48-7.84 9.6.6 3.11 2.9 5.5 5.99 6.19 4.83 1.08 9.15-2.2 9.77-6.67.09-.59-.4-1.12-1-1.12zm-8.02 3v-4.27h-.09l-1.77.63v.69l1.01-.31V16zm3.42-4.22c-.18-.07-.37-.1-.59-.1s-.41.03-.59.1-.33.18-.45.33-.23.34-.29.57-.1.5-.1.82v.74c0 .32.04.6.11.82s.17.42.3.57.28.26.46.33.37.1.59.1.41-.03.59-.1.33-.18.45-.33.22-.34.29-.57.1-.5.1-.82v-.74c0-.32-.04-.6-.11-.82s-.17-.42-.3-.57-.29-.26-.46-.33zm.01 2.57c0 .19-.01.35-.04.48s-.06.24-.11.32-.11.14-.19.17-.16.05-.25.05-.18-.02-.25-.05-.14-.09-.19-.17-.09-.19-.12-.32-.04-.29-.04-.48v-.97c0-.19.01-.35.04-.48s.06-.23.12-.31.11-.14.19-.17.16-.05.25-.05.18.02.25.05.14.09.19.17.09.18.12.31.04.29.04.48v.97z"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  props: ['player', 'playing'],
  methods: {
    rewind: function () {
      var position = this.player.getPosition() - 10 >= 0 ? this.player.getPosition() - 10 : 0;
      this.player.seek(position);
    },
    forward: function () {
      var position = this.player.getPosition() + 10 <= this.player.getDuration() ? this.player.getPosition() + 10 : this.player.getDuration();
      this.player.seek(position);
    },
  },
};
</script>

<style>
</style>